import { t } from 'ember-intl';
import BvBtn from 'volta/components/bv-btn';
import BvSpinner from 'volta/components/bv-spinner';

import type { TOC } from '@ember/component/template-only';

export interface TasksKitSubmitBtnSignature {
  Args: {
    disabled?: boolean;
    fullWidth?: boolean;
    hideSpinner?: boolean;
    loading?: boolean;
    onClick: () => void;
    subtle?: boolean;
  };
  Element: HTMLElement;
}

const TasksKitSubmitBtnComponent: TOC<TasksKitSubmitBtnSignature> = <template>
  {{#unless @hideSpinner}}
    <div>
      {{#if @loading}}
        <BvSpinner @size='sm' />
      {{/if}}
    </div>
  {{/unless}}
  <BvBtn
    @color='primary'
    @onClick={{@onClick}}
    @text={{t 'tasksPage.add'}}
    @disabled={{@disabled}}
    @fullWidth={{@fullWidth}}
    @subtle={{@subtle}}
    ...attributes
  />
</template>;

export default TasksKitSubmitBtnComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'TasksKit::SubmitBtn': typeof TasksKitSubmitBtnComponent;
    'tasks-kit/submit-btn': typeof TasksKitSubmitBtnComponent;
  }
}
